/* eslint-disable @angular-eslint/template/click-events-have-key-events */
/* eslint-disable @angular-eslint/template/mouse-events-have-key-events */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @angular-eslint/no-output-on-prefix */
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, forwardRef, output } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DeButton } from '../models/button.model';
import { Img } from './logo.component';
import { DialogModule } from 'primeng/dialog';
import { ChipModule } from 'primeng/chip';
import { PanelMenuComponent } from "./panel-menu.component";
import { BreadcrumbComponent } from './breadcrumb.component';
import { SharedModule } from '../shared.module';
import { ButtonComponent } from "./button.component";
import { MenuItem } from 'primeng/api';
import { style } from '@angular/animations';

@Component({
  selector: 'ui-ng-navbar',
  standalone: true,

  providers: [
    provideAnimations()
  ],
  template: `

  @switch (layout) {
    @case('horizontal'){
      <p-menubar  [style]="{'background-color': 'var(--primary_color)','border': 'var(--primary_color)', 'border-radius':'0%'}" [styleClass]="class + ' flex flex-row sticky justify-content-between px-6'">
        <ng-template pTemplate="start">
          <div class="flex align-items-center">
            <img class="mx-1 " src="./assets/images/deloitte_logo.png" alt="..." height="15" routerLink="/home">
            <img class="mx-1" src="./assets/images/Line 20.svg" alt="..." height="20">
            <!-- <img class="mx-1" src="./assets/images/generali_logo.svg" alt="..." height="20"> -->
            <img class="mx-1" src="./assets/images/generali_logo.png" alt="..." height="20">
            <!-- <img src="data:image/png;base64, {{ logo }}" height="20" width="20" class="ml-1"/> -->
          </div>
        </ng-template>
        <ng-template pTemplate="end">
          <div class=" flex flex-row align-items-center ">
            <!-- <a class="mx-2 no-underline text-white text-sm" routerLink="../profile">{{
              "Esegui l'accesso"}}</a> -->
            <!-- <div class="picture ">
              <div class="image-container ">
                <img [src]="url ? url : '../../assets/images/img_avatar.png'" class="">
              </div>
            </div> -->
            <div class="flex gap-3 align-items-center ">
                <p class="text-white" style="font-size: 14px;">{{ username }}</p>
                <div style="font-size: 12px;" class="border-round-xl bg-white px-2 py-1">
                  <p style="color: var(--red_text_color)!important;">{{ role }}   </p>     
                </div>
            </div>
            <div class="mx-2 picture" style="border-radius: 50%;" alt="" height="25">
              <div class="image-container ">
                <img [src]="'assets/images/Avatar.svg'" class="image ">
              </div>
              <!-- <i class="fa-solid fa-user fa-md justify-content-center"></i> -->
            </div>
            @if(other_buttons_sections){
              @for(button of other_buttons_sections; track $index){
                <div class="mx-2 picture" style="border-radius: 50%;" alt="" height="25">
                  <div class="image-container ">
                    @if(button?.imgUrl){
                      <img [routerLink]="button?.router_link || undefined" [src]="button.imgUrl" class="image " (click)="onIconClick.emit({message:'iconClicked', $index})">
                    }@else {
                      <a [pTooltip]="collapsed ? button?.tooltip : undefined " [href]="button?.href || undefined">
                        <i [routerLink]="button?.router_link || undefined" [class]=" button.icon + ' mx-2 text-white'" style="background-color: transparent;" (click)="onIconClick.emit({message:'iconClicked', $index})">
                        </i>
                      </a>
                    }
                  </div>
                  <!-- <i class="fa-solid fa-user fa-md justify-content-center"></i> -->
                </div>
              }
            }
            @if(signOutButton){
              <!-- <i class="pi pi-sign-out mx-2 text-white" style="background-color: transparent;" (click)="signOut()">
              </i> -->
            }
          </div>
        </ng-template>
      </p-menubar>
    }

    @case('vertical'){
      @if(showBreadCrumb){
        <ui-ng-breadcrumb id="breadcrumb" #breadcrumb class="fixed " style="padding-top:0.5rem;" style_a="top:0%;"  ngClass=" w-full pl-7  z-5 " [username]="username" [role]="role"></ui-ng-breadcrumb>
      }
      @if(img_profile || other_buttons_sections ){
        <div class="flex absolute mt-2 w-full justify-content-end">
          <div class=" flex flex-row align-items-center w-3 justify-content-end z-5">
            @if(img_profile){
              <div class="mx-2 picture" style="border-radius: 50%;" alt="" height="25">
                <div class="image-container ">
                  <img [src]="'assets/images/Avatar.svg'" class="image ">
                </div>
              </div>
            }
            @if(other_buttons_sections){
              @for(button of other_buttons_sections; track $index){
                <div class="mx-2 picture" style="border-radius: 50%;" alt="" height="25">
                  <div class="image-container ">
                    @if(button?.imgUrl){
                      <img
                        [routerLink]="button?.router_link || undefined"
                        [src]="button.imgUrl" class="image "
                        (click)="onIconClick.emit({message:'iconClicked', $index})">
                    }@else {
                      <a [pTooltip]="button?.tooltip" [href]="button?.href || undefined" [attr.target]="button?.href ? '_blank' : null" [attr.rel]="button?.href ? 'noopener noreferrer' : null">
                        <i
                          [routerLink]="button?.router_link || undefined"
                          [class]=" button.icon + ' mx-2 text-white'"
                          style="background-color: transparent;"
                          (click)="onIconClick.emit({message:'iconClicked', $index})"
                        >
                        </i>
                      </a>
                    }
                  </div>
                  <!-- <i class="fa-solid fa-user fa-md justify-content-center"></i> -->
                </div>
              }
            }
            <!-- @if(signOutButton){
              <i class="pi pi-sign-out mx-2 text-white" style="background-color: transparent;" (click)="signOut()">
              </i>
            } -->
          </div>
        </div>
      }
     
      <div
        #panelElement
        (mouseover)="onMouseout()" 
        id="panel" 
        class=" panel-vertical-menu sticky top-0 z-5 shadow-3 overflow-x-visible "
        [ngClass]="{
          'bg-primary' : collapsed,
          'primary-color-clone' : !collapsed,
          'px-2': !collapsed
        }"
        [ngStyle]="{
          'width': collapsed ? '48px' : '400px' ,
        }"
        >
        @if(locked || !collapsed){
              <ui-ng-button 
                [button]="{icon:'pi pi-times text-500 text-lg'}"
                class="bg-none border-none outline-none border-round-md px-0 "
                ng_class="px-0" 
                [ngClass]="'px-0'"
                (clickEvent)="openPanelClose()"
                [ngStyle]="{
                  'position': 'absolute',
                  'right': '-50px',
                  'padding': '0'
                }"
                ></ui-ng-button>
        }
        <div class="w-full" #panelDoc>
          @if(logo){
            <div class="flex select-none flex align-items-center justify-content-center gap-4 px-2   flex-shrink-1 py-3">
              <!-- <ui-ng-logo [logo]="logo"></ui-ng-logo> -->
              @if(collapsed){
                <img src="assets/images/Athena_logo/LOGO_GEN.svg" alt="" width="50px">
              }

            @else{
                <!-- <p class="text-xl text-white" style="transition:all 0.6s ease-in-out;">{{logo.title}}</p> -->
                <img src="assets/images/Athena_logo/LOGO_Gen_Athena_White.svg" alt="" width="150px">
              }
            </div>
          }
          <ui-ng-panel-menu  [items]="menu_items" [ngClass]="'flex-panel w-full'" #pnl [(collapsed)]="collapsed">
        </ui-ng-panel-menu>
        </div>
          <!-- <ui-ng-list [(collapsed)]="collapsed" [items]="items"></ui-ng-list> -->
          <div [class]="'flex flex-column  w-full gap-2 justify-content-center flex-button-area	'">
            <ui-ng-button 
            [pTooltip]="collapsed ? 'Home' : undefined"
            tooltipPosition="right"  
            tooltipStyleClass="text-sm"
            [button]="{router_link: 'home'}" 
              [icon]="'fa-solid fa-house hover:text-200 text-white ' + ( !collapsed ? 'text-700 text-xl ' : ' text-md') " 
              ng_class="text-sm" 
              [class]="' border-0 h-2rem flex-0 bg-200 home w-1/3 ' + (collapsed ? ' border-0' : '')"
              />
  
              <ui-ng-button 
              [pTooltip]="collapsed ? 'Glossary' : undefined"
                tooltipPosition="right"  
                tooltipStyleClass="text-sm"
                [button]="{ }" 
                  (click)="showDialog()"
                [icon]="'fa-solid fa-info hover:text-200 text-primary bg-white border-round p-1 px-2 ' + ( !collapsed ? 'text-700 text-xl ' : ' text-md') "
                ng_class="text-sm"
                [class]="' border-0 h-2rem flex-0 bg-200 home w-1/3 ' + (collapsed ? ' border-0' : '')"
              />

              @if(incidentLink){
                <ui-ng-button
                [pTooltip]="collapsed ? 'Open Incident' : undefined"
                  tooltipPosition="right"
                  tooltipStyleClass="text-sm"
                  [button]="{ }"
                  (click)="openIncident()"
                  [icon]="'fa-solid fa-triangle-exclamation hover:text-200 text-white ' + ( !collapsed ? 'text-700 text-xl ' : ' text-md') "
                  ng_class="text-sm"
                  [class]="' border-0 h-2rem flex-0 bg-200 home w-1/3 ' + (collapsed ? ' border-0' : '')"
                />
              }

            <ui-ng-button
              [button]="{}"
              [pTooltip]="collapsed ? 'Expand Navbar':'Collapse Navbar'"
              tooltipPosition="right"  
              tooltipStyleClass="text-sm"
              [icon]="'fa-solid   hover:text-200 text-white ' + ( !collapsed ? ' fa-compress-alt text-700 text-xl ' : 'fa-expand-alt  text-md') " 
              ng_class="text-lg border-0 " 
              (click)="openPanelClose()" 
              [class]="' border-primary h-2rem flex-0 home w-1/3 '+ (collapsed ? ' border-0 ' : 'rotate-180 ')"
            ></ui-ng-button>
            <ui-ng-button 
              [pTooltip]="collapsed ? 'Logout' : undefined"
              tooltipPosition="right"  
              tooltipStyleClass="text-sm"
              [button]="{}" 
              [icon]="'fa-solid fa-sign-out hover:text-200 text-white ' + ( !collapsed ? 'text-700 text-xl ' : ' text-md') " 
              ng_class="text-sm" 
              [class]="' border-0 h-2rem flex-0 bg-200 home w-1/3 ' + (collapsed ? ' border-none' : '')"
              (click)="signOut()" 
            />


          </div>

      </div>
      

    }

  }
  <!-- <div class=" flex justify-content-center" [style]="{'background-color': 'var(--primary_color)','border': 'var(--primary_color)', 'z-index':'999'}"> -->
    <!-- <div class="flex h-full overflow-auto relative flex-parent" style="max-height: 95svh;"> 
      <ui-ng-panel styleClass="bg-primary px-3 pb-2 flex flex-column" ngClass="sticky top-0" header="Titolo"></ui-ng-panel>
      <div class="flexaaa h-full overflow-hidden flex flex-column flex-1">
        <ng-content></ng-content>
      </div>

    </div> -->
<!-- <p-panelMenu [model]="[{label:'a'}]" [style]="{'width':'width'}"></p-panelMenu> -->
  <!-- </div> -->
    <p-dialog header="Glossario" [(visible)]="displayDialog" [closable]="true" [modal]="true" [style]="{width: '30vw', height:'fit-content'}">
      <ng-template  pTemplate="header">
          <div style="height: 2.5rem;" class=" flex bg-gray-600 w-fit p-2 px-3 align-items-center border-round border-bottom-noround mb-2 absolute custom-position   " >
            <p class="text-white font-bold text-md">
              Glossary Audit Risk Assessment
            </p> 
          </div>
        </ng-template>
       <!-- <ui-ng-tab-menu  [(activeItem)]="activeItem" [items]="tabs" (activeItemChange)="panel_selected($event)" >
        </ui-ng-tab-menu>
   

        @switch(activeItem['tabIndex']){
         
          @case(0){ -->
          <div class="terms-container  h-full ">
            @for(term of terms; track term) {
              <div class="term-item flex gap-3 p-2 align-items-center" [ngClass]="term.styleClass">
                <div class="term-badge">
                  <span class="term-legend">{{term.legend}}</span>
                </div>
                <div class="term-description">
                  {{ term.description }}
                </div>
              </div>
            }
          </div>

          <!-- }
          @default {
       
          } 
        } -->

        
    <!-- <ng-template pTemplate="footer">
        <div class=" flex gap-2 justify-content-end">
            <ui-ng-button [button]="{
              label: 'Close',
              iconPos: 'right',
              ngClass: 'gap-2 custom-hover'
              }" (click)="displayDialog = false" icon="fa-solid fa-x "
                class=" text-white shadow-1 hover:text-primary justify-content-center">
            </ui-ng-button>
        </div>
    </ng-template> -->
  </p-dialog>
  `,
  styles: ` 
  ::ng-deep.p-dialog-header{
    flex-direction: row-reverse !important;
  }
    .custom-position{
    top: -20px; 
    left: 25px;
  }
/* Layout & items */
.terms-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}
@media (min-width: 480px) {
  .terms-container { grid-template-columns: 1fr; }
}
@media (min-width: 768px) {
  .terms-container { grid-template-columns: 1fr; }
}

.term-item {
  background: var(--surface-card, #ffffff);
  border-left: 4px solid var(--term-color, var(--primary-color, #007bff));
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 0.5rem 0.75rem;
}

.term-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(0,0,0,0.08);
}

/* Badge */
.term-badge {
  background: color-mix(in srgb, var(--term-color, var(--primary-color, #007bff)) 18%, white);
  border: 1px solid var(--term-color, var(--primary-color, #007bff));
  color: #1f2937;
  border-radius: 8px;
  padding: 0.15rem 0.6rem;
  min-width: 64px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.term-legend {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-size: 0.85rem;
  line-height: 1.1;
  white-space: nowrap;
}

.term-description {
  font-size: 0.92rem;
  color: #374151;
  line-height: 1.35;
}

/* Per-term colors using CSS variable for consistency */
.term-au { --term-color: #6B7280; } /* Gray 500 */
.term-ir-i { --term-color: #B91C1C; } /* Red 700 */
.term-ir-l { --term-color: #DC2626; } /* Red 600 */
.term-ics { --term-color: #374151; } /* Gray 700 */
.term-rr { --term-color: #991B1B; } /* Red 800 */
.term-ir-b { --term-color: #9CA3AF; } /* Gray 400 */
.term-ics-b { --term-color: #6B7280; } /* Gray 500 */
.term-l1 { --term-color: #9CA3AF; } /* Gray 400 */
.term-l2 { --term-color: #6B7280; } /* Gray 500 */
.term-l3 { --term-color: #4B5563; } /* Gray 600 */


.primary-color-clone {
	 background-color: var(--primary-color);
}
 ::ng-deep .bg-none {
	 background: transparent !important;
}
 ::ng-deep .bg-none :focus {
	 box-shadow: none !important;
}
 ::ng-deep .p-button.home {
	 justify-self: center !important;
	 display: flex !important;
	 flex: 1 1 auto !important;
	 background: transparent !important;
	 border: transparent !important;
}
 ::ng-deep .p-button.home button {
	 transition: width 1s ease-in !important;
}
 ::ng-deep .p-button.home span {
	 transition: width 1s ease-in !important;
}
 ::ng-deep .p-button.home:hover {
	 border-color: var(--surface-400) !important;
}
 ::ng-deep .p-button.home:hover span.p-button-icon {
	 color: var(--surface-400) !important;
}
 ::ng-deep .p-button.home:focus {
	 box-shadow: none !important;
}
 ::ng-deep .p-button.home span.p-button-label {
	 font-size: 0.5em !important;
	 transition: visibility 1s ease-in !important;
	 padding: 0 !important;
	 flex-grow: 0 !important;
}
 ::ng-deep .p-button.logout {
	 justify-self: center !important;
	 display: flex !important;
	 flex: 1 1 auto !important;
	 padding-inline: 0.5rem !important;
}
 ::ng-deep .p-button.logout:not(.not-collapsed) {
	 background: transparent !important;
}
 ::ng-deep .p-button.logout:focus {
	 box-shadow: none !important;
}
 ::ng-deep .p-button.logout button {
	 transition: width 1s ease-in !important;
}
 ::ng-deep .p-button.logout span {
	 transition: width 1s ease-in !important;
}
 ::ng-deep .p-button.logout span.p-button-label {
	 font-size: 0.8rem !important;
	 transition: visibility 1s ease-in !important;
	 padding: 0 !important;
	 flex-grow: 0 !important;
}
 .panel-vertical-menu {
	 overflow-x: visible !important;
	 height: 100% !important;
	 max-height: 100svh !important;
	 flex-flow: column nowrap !important;
	 display: flex !important;
	 align-items: center !important;
	 transition: width 0.63s ease-in-out, background-color 0.63s ease-in-out;
	 border-radius: 0px 0px 0px 0px;
	 justify-content: space-between !important;
	 padding-bottom: 7svh !important;
	 margin-right: 16px !important;
}
 .panel-vertical-menu .flex-panel {
	 display: flex !important;
}
 .panel-vertical-menu .flex-button-area {
	 display: flex !important;
	 flex-flow: row wrap !important;
	 transition: display 1s ease-in-out !important;
}
 ::ng-deep p-panel {
	 display: flex;
	 height: 100%;
}
 ::ng-deep p-panel .p-panel {
	 position: sticky;
}
 ::ng-deep p-panel .p-toggleable-content {
	 height: 100%;
}
 ::ng-deep .p-panel .p-panel-content {
	 display: flex;
	 padding: 0.25rem;
	 border: 1px solid #e5e7eb;
	 background: #fff;
	 color: #4b5563;
	 overflow: auto;
	 border-top: 0 none;
	 height: 100%;
}
 .notification {
	 color: palegoldenrod;
}
 .customHeader {
	 z-index: 999;
}
 .circle {
	 border-radius: 50%;
	 display: flex;
	 position: absolute;
	 width: 11px;
	 height: 11px;
	 background-color: var(--primary_color);
	 bottom: 0.4px;
	 right: -1px;
}
 .picture {
	 display: flex;
	 width: 2em;
	 height: 2em;
	 border-radius: 50%;
	 justify-content: center;
	 align-items: center;
	 background-color: var(--primary_color);
}
 .image {
	 object-position: 50% 50%;
	 object-fit: fill;
	 width: 1.8em;
	 height: 1.8em;
	 border-radius: 50%;
}
 .image-container {
	 position: relative;
	 display: inline-block;
	 text-align: center;
}
 @keyframes shake {
	 0% {
		 rotate: 0deg;
	}
	 10% {
		 rotate: 10deg;
	}
	 30% {
		 rotate: -10deg;
	}
	 45% {
		 rotate: 5deg;
	}
	 55% {
		 rotate: -5deg;
	}
	 60% {
		 rotate: 0deg;
	}
}
 .animation {
	 animation: shake 1s 3;
}
 
  `,
  imports: [SharedModule, MenubarModule, forwardRef(() => ButtonComponent), PanelMenuComponent, BreadcrumbComponent, DialogModule, ChipModule]
})

export class NavbarComponent {
  @Input() class = ''
  @Input() signOutButton = true;
  @Output() onIconClick: EventEmitter<{ message: string, $index: number }> = new EventEmitter<{ message: string, $index: number }>()
  @Output() onSignOut: EventEmitter<string> = new EventEmitter<string>()
  @Input() other_buttons_sections: NavBarButtonAddons[] = [];
  @Input() incidentLink: string | undefined;
  @Input() username = 'Mario rossi';
  @Input() role = 'End User';
  @Input() layout: 'vertical' | 'horizontal' = 'vertical';
  @ViewChild('pnl', { static: false }) panel: PanelMenuComponent | undefined
  @ViewChild('breadcrumb', { static: false }) bb: HTMLElement | undefined
  @Input() showBreadCrumb = false;
  @Input() menu_items: MenuItem[] | undefined;
  @Input() items: Partial<DeButton>[] | undefined;
  @Input() locked = false;
  lockedChange = output<boolean>();
  @Input() collapsed = true;
  collapsedChange = output<boolean>();
  @ViewChild('panelElement', { static: false }) panelElement: ElementRef | undefined;
  @ViewChild('panelDoc', { static: false }) panelDoc: ElementRef | undefined;
  @Input() logo: Img | undefined = {
    width: 130,
    height: 0,
    title: "R/A Platform",
    imgUrl: {
      url: "assets/images/DelLogo.png"
    },
    style: 'filter:brightness(100)'
  };
  resized = false
  @Input() img_profile = false;
  menu_itemsTmp: MenuItem[] | undefined;
  currentTabIndex = 0;

  displayDialog = false;
  tabs: MenuItem[] = [
    {
      label: 'Risk',
      icon: 'fa-solid fa-calendar-days',
      tabIndex: 0
    },
    {
      label: 'Legend',
      icon: 'fa-solid fa-calendar-days',
      tabIndex: 1
    }
    // {
    //   label: 'General Info',
    //   icon: 'fa-solid fa-calendar-days',
    //   tabIndex: 2,
    // },
  ];
  activeItem = this.tabs[0];

  terms = [
    {
      legend: "AU",
      description: "Auditable Universe",
      styleClass: 'term-ir-i'
    },
    {
      legend: "IR - I",
      description: "Inherent Risk Impact",
      styleClass: 'term-ir-i'
    },
    {
      legend: "IR - L",
      description: "Inherent Risk Likelihood",
      styleClass: 'term-ir-i'
    },
    {
      legend: "IR",
      description: "Inherent Risk",
      styleClass: 'term-ir-i'
    },
    {
      legend: "ICS",
      description: "Internal Control System",
      styleClass: 'term-ir-i'
    },
      {
        legend: "RR",
      description: "Residual Risk",
      styleClass: 'term-ir-i'
    },
    {
      legend: "IR - B",
      description: "Inherent Risk Baseline",
      styleClass: 'term-ir-i'
    },
    {
      legend: "ICS - B",
      description: "Internal Control System Baseline",
      styleClass: 'term-ir-i'
    },
    {
      legend: "L1",
      description: "Process Level 1",
      styleClass: 'term-ir-i'
    },
    {
      legend: "L2",
      description: "Process Level 2",
      styleClass: 'term-ir-i'
    },
    {
      legend: "L3",
      description: "Process Level 3",
      styleClass: 'term-ir-i'
    }
  ];
  @HostListener('document:scroll', ['$event'])
  onScroll(e: any) {
    // //console.logwindow.scrollY)
    if (window.scrollY > 100) {
      this.resized = true;
      document.getElementById('breadcrumb')?.setAttribute('style', 'padding-top:0rem !important;backdrop-filter:blur(8px);background: rgba(246,247,249,.8) !important;--webkit-backdrop-filter:blur(8px);transition:all 0.6s ease-in-out!important;');
    }

    if (window.scrollY <= 99) {
      this.resized = false
      document.getElementById('breadcrumb')?.setAttribute('style', 'padding-top:0.5rem !important;backdrop-filter:none;background: transparent !important;--webkit-backdrop-filter:none;transition:all 0.4s ease-in-out!important;');
    }
    if (window.scrollY > 0 && !this.resized) {
      document.getElementById('breadcrumb')?.setAttribute('style', 'padding-top:0rem !important;backdrop-filter:blur(8px);background: rgba(246,247,249,.8) !important;--webkit-backdrop-filter:blur(8px);transition:all 0.1s ease-in-out!important;');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.panelElement?.nativeElement.contains(event.target) && !(event.target instanceof SVGElement)) {
      if (this.locked) {
        this.openPanelClose()
      }
    }
  }

  onMouseover() {
    if (!this.locked) {
      this.collapsed = false;
    }
  }

  showDialog() {
    this.displayDialog = true;
  }
  onMouseout() {
    // // //console.log"OnMouse out");

    if (!this.locked) {
      this.collapsed = true;
    }
  }

  openPanelClose() {
    this.locked = !this.locked;
    this.collapsed = !this.collapsed;
    if (this.collapsed) {
      this.menu_items = this.menu_items?.map((item, index) => {
        return { ...item, tooltip: this.menu_itemsTmp?.[index]?.tooltip }
      })
      this.panel!.expanded = false;
      this.panel!.collapseAll();
    } else {
      this.menu_itemsTmp = structuredClone(this.menu_items)
      this.menu_items = this.menu_items?.map(item => {
        const { tooltip, ...button } = item;
        return button
      })
    }
  }


  panel_selected(event: any) {
    if (event) {
      this.currentTabIndex = event.tabIndex;
      this.activeItem = this.tabs[this.currentTabIndex];
    }
    //console.logthis.currentTabIndex);
  }

  // onMouseover(event: MouseEvent): void {
  //   this.collapsed = false;
  //     // //console.log'hover',event, event.target);
  // }

  signOut() {
    this.onSignOut.emit('Bye Bye');
  }

  openIncident(): void {
    if (this.incidentLink) {
      const anchor = document.createElement('a');
      anchor.href = this.incidentLink;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.click();
    }
  }


  // ngAfterViewInit() {
  // const panel = document.getElementById('panel')!
  // panel.addEventListener('click', () => {
  //   // //console.log'hover');
  // })
  // }
}



export type NavBarButtonAddons = {
  imgUrl?: string;
  icon?: string;
  router_link?: string;
  href?: string;
  tooltip?: string;
}

/**
 * 
 * 
 * 
 * 
 * .p-panel .p-panel-content {
    display: flex;
    padding: 1.25rem;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    color: #4b5563;
    border-top: 0 none;
    height: 100%;
}



REGION
    min-height: 100%;

 */
export const MENU_HOME = { label: 'Home', icon: 'fa-solid fa-house' }
